"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EpicGamesFooterInner = void 0;
const react_1 = __importStar(require("react"));
const SocialAndTopBtn_molecule_1 = require("./components/social/SocialAndTopBtn.molecule");
const HR_atom_1 = require("./components/atoms/HR.atom");
const LegalLinksAndLogos_molecule_1 = require("./components/legal/LegalLinksAndLogos.molecule");
const Copyrights_molecule_1 = require("./components/legal/Copyrights.molecule");
const defaultMessages_1 = require("./constants/defaultMessages");
const shared_1 = require("./shared");
const LinksAndLegalTags_molecule_1 = require("./components/links/LinksAndLegalTags.molecule");
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const EpicGamesFooterInner = ({ socialLinks, newLineCopyrights, copyrights, hideDefaultTermsPolicy, moreLegalLinks, logos, links, mainLinksSubTitle, secondaryLinksSubTitle, secondaryLinks, linkColumns, legalTags, enableNewsLetter, newsLetterConfigs, newsLetterReactConfig, isLoggedIn, email, epicLogoConfig = {}, messages }) => {
    const { setMessages } = (0, shared_1.useMessages)();
    const locale = (0, epic_games_nav_shared_1.useLocalizationLocale)();
    (0, react_1.useEffect)(() => {
        setMessages(Object.assign(Object.assign({}, defaultMessages_1.defaultMessages), messages));
    }, [setMessages]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SocialAndTopBtn_molecule_1.SocialAndTopBtn, { socialLinks: socialLinks, locale: locale }),
        react_1.default.createElement(LinksAndLegalTags_molecule_1.LinksAndLegalTags, { links: links, mainLinksSubTitle: mainLinksSubTitle, secondaryLinksSubTitle: secondaryLinksSubTitle, secondaryLinks: secondaryLinks, linkColumns: linkColumns, legalTags: legalTags, locale: locale, enableNewsLetter: enableNewsLetter, newsLetterConfigs: newsLetterConfigs, newsLetterReactConfig: newsLetterReactConfig, isLoggedIn: isLoggedIn, email: email }),
        react_1.default.createElement(HR_atom_1.HR, null),
        react_1.default.createElement(Copyrights_molecule_1.Copyrights, { newLineCopyrights: newLineCopyrights, copyrights: copyrights }),
        react_1.default.createElement(LegalLinksAndLogos_molecule_1.LegalLinksAndLogos, { locale: locale, hideDefaultTermsPolicy: hideDefaultTermsPolicy, moreLegalLinks: moreLegalLinks, logos: logos, epicLogoConfig: epicLogoConfig })));
};
exports.EpicGamesFooterInner = EpicGamesFooterInner;
//# sourceMappingURL=EpicGamesFooterInner.js.map